import { Component, AfterViewInit, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'translate-select',
  templateUrl: './translate-select.component.html',
  styleUrls: ['./translate-select.component.scss']
})
export class TranslateSelectComponent {
  language: string;
  lenguages: any[] = [{ value: 'es-Mx', text: 'Español' }, { value: 'en-Us', text: 'English' }];
  constructor(private translate: TranslateService) {
  }
  onChange() {
    this.translate.setDefaultLang(this.language);
    this.translate.use(this.language);

  }
}
